export function validateZonePayload({
  countryId,
  departmentId,
  provinceId,
  name,
  isSpecial,
  multiplier,
  resolution,
  polygon,
}) {
  if (!countryId) {
    return "El pais es obligatorio.";
  }
  if (!departmentId) {
    return "El departamento es obligatorio.";
  }
  if (!provinceId) {
    return "La provincia es obligatoria.";
  }
  if (!name || !name.trim()) {
    return "El nombre la Zona obligatorio.";
  }

  if (typeof isSpecial !== "boolean") {
    return "El indicador especial es obligatorio.";
  }

  if (
    multiplier === "" ||
    multiplier === null ||
    multiplier === undefined ||
    Number.isNaN(Number(multiplier))
  ) {
    return "El multiplicador es obligatorio.";
  }

  if (Number(multiplier) < 1) {
    return "El multiplicador debe ser minimo 1.00.";
  }

  if (!resolution) {
    return "La resolución H3 es obligatoria.";
  }

  if (Number(resolution) < 0 || Number(resolution) > 15) {
    return "La resolución H3 debe estar entre 0 y 15.";
  }

  if (!polygon || polygon.length < 3) {
    return "Debe dibujar un polígono con mínimo 3 puntos.";
  }

  const invalidPoint = polygon.some(
    (point) =>
      typeof point.latitude !== "number" || typeof point.longitude !== "number",
  );

  if (invalidPoint) {
    return "El polígono contiene coordenadas inválidas.";
  }

  return null;
}
